<template>
  <div>
    <el-dialog title='封面模板选择' :visible.sync='dialogVisible'>
      <div>
        <div v-for='(coverTpl,index) in coverTplMap' :key='index'>
          <div class='cover-tpl' @click='handleSelect(coverTpl)'>{{coverTpl.title}} </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import plcMap from '@/json/plc.json'

export default {
  name: 'PlcCoverTplSelector',
  data() {
    return {
      dialogVisible: false,
      coverTplMap: plcMap.cover_tpl
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleSelect(coverTpl){
      this.dialogVisible = false
      this.$emit('choice',coverTpl)
    }
  }
}
</script>
<style scoped>
.cover-tpl{
  height: 20px;
  line-height: 20px;
  padding: 10px;
  cursor: pointer;
}
.cover-tpl:hover{
  color: #F2F2F2;
  background-color: #fe2d54;
}
</style>
